// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__3K5C-","paginationMeta":"Pagination_paginationMeta__2lpN2","paginationLoading":"Pagination_paginationLoading__1u121"};